import React from 'react';

import { connect } from 'react-redux';
import { FormattedMessage } from 'translations';
import { Layout } from 'app/components/base/Layout';
import InteractiveCheckbox from './commons/InteractiveCheckbox';
import {
  SAVE_TA_PROFILE_FIELD_NAME,
  SAVE_TA_CC_FIELD_NAME,
  SELECTED_CUSTOMER_PROFILE,
} from 'app/constants';
import {
  behavesAsTravelAgent,
  getBookTripFormValue,
} from 'app/sagas/selectors';

import style from './style.css';

const messages = {
  saveProfileTitle: { id: 'BOOK_TRIP.SAVE_PROFILE.SAVE_PROFILE_TITLE' },
  saveProfileDescription: {
    id: 'BOOK_TRIP.SAVE_PROFILE.SAVE_PROFILE_DESCRIPTION',
  },
  updateProfileTitle: { id: 'BOOK_TRIP.SAVE_PROFILE.UPDATE_PROFILE_TITLE' },
  updateProfileDescription: {
    id: 'BOOK_TRIP.SAVE_PROFILE.UPDATE_PROFILE_DESCRIPTION',
  },
  saveCCTitle: { id: 'BOOK_TRIP.SAVE_PROFILE.SAVE_CC_TITLE' },
  saveCCDescription: { id: 'BOOK_TRIP.SAVE_PROFILE.SAVE_CC_DESCRIPTION' },
  updateCCTitle: { id: 'BOOK_TRIP.SAVE_PROFILE.UPDATE_CC_TITLE' },
  updateCCDescription: { id: 'BOOK_TRIP.SAVE_PROFILE.UPDATE_CC_DESCRIPTION' },
};

/**
 * Component with inputs to save a TA profile from the data entered in the BTP
 */
const SaveProfile = ({ behavesAsTA, hasSelectedProfile }) => {
  const compMessages = hasSelectedProfile
    ? {
        profileTitle: messages.updateProfileTitle,
        profileDescription: messages.updateProfileDescription,
        ccTitle: messages.updateCCTitle,
        ccDescription: messages.updateCCDescription,
      }
    : {
        profileTitle: messages.saveProfileTitle,
        profileDescription: messages.saveProfileDescription,
        ccTitle: messages.saveCCTitle,
        ccDescription: messages.saveCCDescription,
      };
  return (
    behavesAsTA && (
      <Layout className={style.container}>
        <InteractiveCheckbox
          icon="customer-profile"
          fieldName={SAVE_TA_PROFILE_FIELD_NAME}
          title={<FormattedMessage {...compMessages.profileTitle} />}
          description={
            <FormattedMessage {...compMessages.profileDescription} />
          }
          className={style.item}
        />
        <InteractiveCheckbox
          icon="ta-credit-card"
          fieldName={SAVE_TA_CC_FIELD_NAME}
          title={<FormattedMessage {...compMessages.ccTitle} />}
          description={<FormattedMessage {...compMessages.ccDescription} />}
          className={style.item}
        />
      </Layout>
    )
  );
};

// TODO: move to Flow types
// SaveProfile.propTypes = {
//   behavesAsTA: PropTypes.bool,
//   hasSelectedProfile: PropTypes.bool
// };

const mapStateToProps = (state) => ({
  behavesAsTA: behavesAsTravelAgent(state) || null,
  hasSelectedProfile: !!getBookTripFormValue(state, SELECTED_CUSTOMER_PROFILE),
});

export default connect(mapStateToProps)(SaveProfile);
